import React, { useMemo } from 'react';
import { Box, Container } from '@chakra-ui/react';
import RewardSetFadeSlideshow from './RewardSetFadeSlideshow';
import { buildCatalogSlides, buildRewardSetSlides } from './rewardSetSlides';

const HERO_OVERLAY =
  'linear(to-b, rgba(15, 23, 42, 0.82) 0%, rgba(15, 23, 42, 0.45) 45%, rgba(15, 23, 42, 0.75) 100%)';

/**
 * Hero full-width: slideshow fade casuale sui premi del set (o di tutti i set in catalogo).
 */
const RewardSetHero = ({
  rewardSet,
  sets,
  altFallback = 'Premio',
  minH = { base: '44vh', md: '400px' },
  children,
}) => {
  const slides = useMemo(() => {
    if (rewardSet) {
      return buildRewardSetSlides(rewardSet, { shuffle: true });
    }
    if (sets?.length) {
      return buildCatalogSlides(sets, { shuffle: true });
    }
    return [];
  }, [rewardSet, sets]);

  return (
    <Box
      as="section"
      position="relative"
      w="100%"
      minH={minH}
      display="flex"
      alignItems="flex-end"
      overflow="hidden"
      bg="purple.900"
    >
      {slides.length > 0 ? (
        <Box position="absolute" inset={0}>
          <RewardSetFadeSlideshow slides={slides} altFallback={altFallback} />
        </Box>
      ) : (
        <Box
          position="absolute"
          inset={0}
          bgGradient="linear(135deg, purple.800 0%, purple.600 50%, brand.600 100%)"
        />
      )}

      <Box
        position="absolute"
        inset={0}
        bgGradient={HERO_OVERLAY}
        zIndex={2}
        pointerEvents="none"
      />

      <Container
        maxW="container.xl"
        position="relative"
        zIndex={3}
        w="full"
        py={{ base: 10, md: 12 }}
        px={{ base: 4, md: 6 }}
      >
        {children}
      </Container>
    </Box>
  );
};

export default RewardSetHero;
